import { getRoute, useLayout } from '@/functions';

export default {
    path: '/',
    component: useLayout('oauth-login'),
    children: [
        getRoute('/oauth-login', 'accountsOAuthLogin', 'oauth/oauth_login_page', { title: 'Accounts OAuth Login' }),
    ],
};
